// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"348":"12a4e77a0434041595ca","418":"5485fbf5f83df615754e","726":"a024440333231fcc4b99","913":"5178773b1eb1d99ae97e"}[chunkId] + ".js";
};